import React from 'react';
import { DeviceCode } from 'packages/smart-home-support/models';
import { theme } from 'packages/smart-home-support/themes';
import { DeviceIconCode, DeviceIconSVGType, DeviceIconProps } from './models';
import * as icons from './icons';

const deviceIconCodeMap: Record<DeviceCode, DeviceIconCode> = {
  desktop: 'Desktop',
  dvdPlayer: 'DVDPlayer',
  fitness: 'Fitness',
  gamingConsole: 'GameConsole',
  laptop: 'Laptop',
  printer: 'Printer',
  router: 'Router',
  smartCamera: 'SecurityCamera',
  smartSpeaker: 'Speaker',
  smartThermostat: 'Thermostat',
  smartWatch: 'Watch',
  streaming: 'Streaming',
  tablet: 'Tablet',
  tv: 'TV',
  wirelessSpeaker: 'WirelessSpeaker',
};

const Icon: React.FC<DeviceIconProps> = ({ deviceType, isAccented }) => {
  const IconComponent: DeviceIconSVGType = icons[deviceIconCodeMap[deviceType]];

  return IconComponent ? <IconComponent accentColor={isAccented ? theme.colors.deviceIconAccent : '#000'} /> : <></>;
};

export default Icon;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DeviceIcon/DeviceIcon.tsx